import * as THREE from '@phdsoft/three';

/**
 * True only when the GPU would really write this surface into the depth buffer
 * and hide what is behind it: every material must be visible, write and test
 * depth, and be fully opaque (transparent with opacity 1 still counts — the
 * structure basicMaterial is `transparent: true, opacity: 1`).
 *
 * Pass the mesh's current `material`; view-mode mask clones are assigned to
 * the mesh, so that is the effective material for the frame.
 */
export function materialOccludes(material: THREE.Material | THREE.Material[] | null | undefined): boolean {
  if (!material) {
    return false;
  }
  if (Array.isArray(material)) {
    return material.length > 0 && material.every(m => materialOccludes(m));
  }
  return material.visible
    && material.depthWrite
    && material.depthTest
    && (!material.transparent || material.opacity >= 1);
}
